export default __webpack_public_path__ + "static/media/tel.81dd445a.png";